<template>
  <div id="app">
    <ring-loader :loading="store.loading"></ring-loader>
    
    <div class="main-wrapper">
      <router-view />
    </div>
  </div>
</template>
<script setup>
import { useAppStore } from '@/stores';

const store = useAppStore();
</script>
